// Social proof inside the builder (2026-07-19): a horizontal strip of
// real customers' review photos, curated in ../examples.ts. Sits below
// the customise section so the "will it actually look good?" doubt gets
// answered while the customer designs. Images lazy-load so the strip
// costs nothing until scrolled near.

import { STITCHED_EXAMPLES } from "../examples";

export function ExamplesStrip() {
  if (STITCHED_EXAMPLES.length === 0) return null;
  return (
    <section className="rk-pc-examples" aria-label="Examples from real orders">
      <span className="rk-pc-examples__title">Stitched for real customers</span>
      <span className="rk-pc-examples__sub">
        Straight from our reviews, machine-embroidered in Melbourne
      </span>
      <div className="rk-pc-examples__row">
        {STITCHED_EXAMPLES.map((e) => (
          <figure key={e.img} className="rk-pc-examples__card">
            <img src={e.img} alt={e.caption} loading="lazy" decoding="async" />
            <figcaption>{e.caption}</figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
